import React from "react";
import classes from './Footer.module.css'

function Footer() {
    return (
        <div className={classes.footer}>
            <p>CopyRight 2022-TDK</p>
        </div>
    );
}

export default Footer;